import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { type LocalNumbersRoutes } from 'pages/settings/pages/compliance/pages/localNumbers/route/type'

import { useComplianceLayerContext } from 'pages/settings/pages/compliance/context/complianceLayerContext'
import {
  LocalNumbersStepsProvider,
  useLocalNumbersStepsContext,
} from 'pages/settings/pages/compliance/pages/localNumbers/context/localNumbersStepsContext'

import { useProgressInfoTitle } from '../hooks/useProgressInfoTitle'

export const LocalNumbersLayoutContent = observer(() => {
  const {
    useCaseStore,
    allStepsLength,
    campaignId,
    complianceLayerStore,
    decreaseStep,
    closeSetting,
    getSettingsStep,
    aiSidebarStore,
  } = useLocalNumbersStepsContext()

  const { getCampaignData } = complianceLayerStore

  useEffect(() => {
    useCaseStore.loadUseCases()
    if (!campaignId) {
      getCampaignData()
    }
  }, [])

  const settingsStep = useGetStep<LocalNumbersRoutes>(getSettingsStep)

  return (
    <StepsCommonLayout
      progressTitle={useProgressInfoTitle()}
      totalSteps={allStepsLength}
      title='A2P 10DLC'
      settingsStep={settingsStep}
      closeSetting={closeSetting}
      decreaseStep={(lastPathSegment) => decreaseStep(lastPathSegment as LocalNumbersRoutes)}
      sidebarStore={aiSidebarStore}
    />
  )
})

export const LocalNumbersStepsLayout = () => {
  const complianceLayerStore = useComplianceLayerContext()

  return (
    <LocalNumbersStepsProvider complianceLayerStore={complianceLayerStore}>
      <LocalNumbersLayoutContent />
    </LocalNumbersStepsProvider>
  )
}
